"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _echarts_props = require("./echarts_props");

var _is_equal = _interopRequireDefault(require("./utils/is_equal"));

var _addjs = _interopRequireDefault(require("./utils/addjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Echarts =
/*#__PURE__*/
function (_Component) {
  _inherits(Echarts, _Component);

  function Echarts(props) {
    var _this;

    _classCallCheck(this, Echarts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Echarts).call(this, props));

    _this.nullList();

    return _this;
  }

  _createClass(Echarts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.genChart();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      // 不想等才进行重新渲染，不然会导致Chart一直在变化
      return !((0, _is_equal["default"])(this.props, nextProps) && (0, _is_equal["default"])(this.state, nextState));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.genChart();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.chartRef = null;
      this.chart = null;
    }
  }, {
    key: "genChart",
    value: function genChart() {
      var _this2 = this;

      var _this$props = this.props,
          chartCallback = _this$props.chartCallback,
          theme = _this$props.theme,
          _this$props$renderer = _this$props.renderer,
          renderer = _this$props$renderer === void 0 ? 'canvas' : _this$props$renderer,
          _this$props$opts = _this$props.opts,
          opts = _this$props$opts === void 0 ? {} : _this$props$opts,
          _this$props$notMerge = _this$props.notMerge,
          notMerge = _this$props$notMerge === void 0 ? true : _this$props$notMerge,
          lazyUpdate = _this$props.lazyUpdate,
          replaceMerge = _this$props.replaceMerge,
          echartProps = _objectWithoutProperties(_this$props, ["chartCallback", "theme", "renderer", "opts", "notMerge", "lazyUpdate", "replaceMerge"]); // 没有组件，啥都没得搞


      (0, _addjs["default"])(function () {
        // 如果是希望获取chart的实例，可以通过callback
        if (_this2.chartRef) {
          // 必须有实例才能够渲染
          _this2.chart = echarts.init(_this2.chartRef, theme, _objectSpread({
            renderer: renderer
          }, opts));

          if ((0, _spauiUtils.isFunction)(chartCallback)) {
            chartCallback(_this2.chart);
          }

          _this2.chart.setOption(echartProps, {
            notMerge: notMerge,
            replaceMerge: replaceMerge,
            lazyUpdate: lazyUpdate
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-echarts'
      }, Echarts), {
        ref: function ref(el) {
          _this3.chartRef = el;
        }
      }));
    }
  }]);

  return Echarts;
}(_react.Component); // 组件标记


_defineProperty(Echarts, "propTypes", _echarts_props.propTypes);

_defineProperty(Echarts, "defaultProps", _echarts_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Echarts, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Echarts;
exports["default"] = _default;